import { Form, Grid, Image, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { H6, P3 } from "../../../../../../components/NormalFonts";
import { useLayout } from "../../../../../../context/LayoutContext";
import { handleClickCS } from "../../../../../../plugins/utils";
import { searchMode } from "../../../../enumerations/searchMode";
import { step } from "../../../../enumerations/step";
import styles from "./styleModule";

const FilterBarContainer = ({
  selectedSearchMode,
  setSelectedSearchMode,
  stepsEnum,
  steps,
  form,
}: {
  selectedSearchMode: string;
  setSelectedSearchMode: (value: string) => void;
  stepsEnum: any;
  steps: any;
  form: any;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { getContentPadding } = useLayout();

  const getBottom = () => {
    if (screens.lg) return "100px";
    if (screens.md) return "30px";
    if (screens.sm) return "108px";
    return "126px";
  };

  const getBodyPadding = () => {
    if (screens.lg) return "28px";
    return "16px 14px";
  };

  const headerEnum = [
    {
      key: searchMode.RESORT,
      title: t("home.searchbar.byresort"),
      image: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/home/search_default.png`,
      selectedImage: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/home/search_selected.png`,
    },
    {
      key: searchMode.DATE,
      title: t("home.searchbar.bydate"),
      image: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/home/calendar_default.png`,
      selectedImage: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/home/calendar_selected.png`,
    },
    {
      key: "coach",
      title: t("home.searchbar.bycoach"),
      image: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/home/coach_default.png`,
      selectedImage: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/home/coach_selected.png`,
      path: "/trainers",
    },
  ];

  const trustItems = [
    {
      image: "trustshield.png",
      title: t("home.trust.resort.title"),
      text: t("home.trust.resort.text"),
    },
    {
      image: "trustcasi.png",
      title: t("home.trust.casi.title"),
      text: t("home.trust.casi.text"),
    },
    {
      image: "trustchat.png",
      title: t("home.trust.chinese.title"),
      text: t("home.trust.chinese.text"),
    },
    {
      image: "trustcompany.png",
      title: t("home.trust.japan.title"),
      text: t("home.trust.japan.text"),
    },
    {
      image: "trustmountain.png",
      title: t("home.trust.area.title"),
      text: t("home.trust.area.text"),
    },
    {
      image: "trustyuzawa.png",
      title: t("home.trust.yuzawa.title"),
      text: t("home.trust.yuzawa.text"),
    },
  ];

  return (
    <div
      className={styles.filterBarContainer}
      style={{ padding: getContentPadding(), bottom: getBottom() }}
    >
      <div className={styles.headerContainer}>
        {headerEnum.map((item) => (
          <div
            key={item.key}
            className={`${styles.titleWrapper} ${
              selectedSearchMode === item.key ? styles.selected : ""
            }`}
            onClick={() => {
              if (item.path) {
                navigate(item.path);
                return;
              }

              setSelectedSearchMode(item.key);
            }}
          >
            <Image
              className={styles.imageTitle}
              src={
                selectedSearchMode === item.key
                  ? item.selectedImage
                  : item.image
              }
              preview={false}
            />

            <H6 className={styles.title} weight={"medium"}>
              {item.title}
            </H6>
          </div>
        ))}
      </div>

      <div
        className={styles.bodyContainer}
        style={{
          padding: getBodyPadding(),
          width: stepsEnum[steps].bodyWidth,
        }}
      >
        <Form
          variant={screens.lg ? "filled" : "outlined"}
          style={{ width: "100%" }}
          autoComplete={"off"}
          onFinish={stepsEnum[steps].handleOk}
          form={form}
          requiredMark={steps === step.FULL_SEARCH}
          layout={"vertical"}
          initialValues={{ adults: "0", kids: "0" }}
        >
          <Row
            style={{ width: "auto" }}
            gutter={screens.lg ? [22, 0] : [12, 12]}
          >
            {stepsEnum[steps].content}
            {stepsEnum[steps].btn}

            {stepsEnum[steps].showHint && (
              <P3
                className={styles.hint}
                style={{
                  transform: screens.lg ? "translateX(50%)" : "unset",
                }}
              >
                {t("home.filterBar.hint")}

                <span className={styles.cs}>
                  <a onClick={handleClickCS}>{t("normal.contactCS")}</a>
                </span>
              </P3>
            )}
          </Row>
        </Form>
      </div>

      <div className={styles.trustContainer}>
        {trustItems.map((item) => (
          <div className={styles.trustItem} key={item.title}>
            <img
              src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/home/${item.image}`}
              alt=""
            />

            <div className={styles.trustContent}>
              <div className={styles.trustTitle}>{item.title}</div>
              <div className={styles.trustText}>{item.text}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterBarContainer;
